import React, { Component } from 'react';
import { Provider } from 'react-redux';

import Routes from './components/container/Routes/Routes';
import store from './redux/store';

import './styles/semantic-ui-overrides.scss';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Routes />
      </Provider>
    );
  }
}
export default App;
